


























import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeOption, {OptionFilter} from '@/stores/modules/option';

import TrueFalseMultiSelect from '@/components/Input/TrueFalseMultiSelect.vue';

@Component({
	components: {
		TrueFalseMultiSelect,
	}
})
export default class CrudOptionFilter extends Vue {

	@Prop({ type: Boolean, default: false}) reduce;

	@Stored(() => storeOption) private page!: number;
	@Stored(() => storeOption) private filters!: OptionFilter;

	@WatchObjectProperties('filters', OptionFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeOption.dispatch('getC', { filters: true });
	}

}
